import {
  Box,
  Grid,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { useUserControl } from "../../../context/SuperAdmin/UserControlContext";
import SearchIcon from "@mui/icons-material/Search";
import { Button } from "@aws-amplify/ui-react";
import AllUsersPagination from "./UsersPagination";
import PickVersion from "./PickVersion";

const HeadersAllUsers = () => {
  const { search, changeSearch } = useUserControl();
  return (
    <Grid
      container
      sx={{ justifyContent: "space-between", alignContent: "center" }}
    >
      {/* Search bar */}
      <Grid item>
        <TextField
          size="small"
          variant="outlined"
          placeholder="Ej: andres"
          value={search}
          onChange={(e) => changeSearch(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Grid>

      <Box sx={{ display: "flex", gap: 4, alignItems: "center" }}>
        <AllUsersPagination />
        <PickVersion />
      </Box>
    </Grid>
  );
};

export default HeadersAllUsers;
